import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { useQuery } from 'react-query';
import { OrganizationKeys } from './organization.keys';

export const getAvailableLicenses = async () => {
  const response = await clients.admin.get(`/organizationlicenses/available`);
  return response.data as string[];
};

export const useGetAvailableLicenses = () =>
  useQuery(OrganizationKeys.availableLicenses(), () => getAvailableLicenses(), {});
